import styled from "styled-components";

export const CreditCardFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  width: 100%;

  gap: 2rem;
`;

export const CreditCardFields = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  width: 100%;
`;

export const WrapperCreditCardInputs = styled.div`
  display: grid;
  align-items: flex-end;
  justify-content: center;

  gap: 1rem;
  grid-template-areas: "number expiration_date cvv";
  grid-template-columns: 1fr 6.25rem 5.3rem;

  width: 100%;
  margin: 0 0 1rem;

  .expiration_date {
    grid-area: expiration_date;
    margin: 2rem 0 0;
  }

  .cvv {
    grid-area: cvv;
    margin: 2rem 0 0;
  }

  @media (max-width: 875px) {
    .expiration_date,
    .cvv {
      margin: 0;
    }

    grid-template-areas:
      "number number"
      "expiration_date cvv";

    grid-template-columns: 1fr 1fr;
  }
`;

export const Title = styled.h2`
  font-family: Inter;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.688rem;
  color: ${({ theme }) => theme.checkoutOnePage?.textColor};

  margin: 0 0 1rem;
`;
